import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
} from "react-native";

import Breakpoints from "react-native-dimensions-breakpoints";
import StyledIcon from "./StyledIcon";
import StyledText from "./StyledText";
import Style from "ae-style";

import { useIdPrefix } from "@aetonix/hooks";

const styles = StyleSheet.create({
	content: {
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
	},
	disabled: {
		opacity: Style.look.disabled,
	}
});

export default function VerticalButton(props){
	const idPrefix = useIdPrefix();
	const children = props.children;
	let onPress = props.onPress;
	let color = props.color || Style.colors.secondary;
	let tertiary = false;
	if(props.tertiary){
		color = Style.colors.tertiary;
		tertiary = true;
	}

	const id = props.id;
	const styleList = [styles.content, props.style];
	const icon = props.icon;
	const title = props.title;
	const contrast = props.contrast;
	const isAta = props.buttonColor;
	const iconSize = Breakpoints.smallerThan("mobile") ? "emphasized" : "large";
	const textSize = Breakpoints.smallerThan("mobile") ? "small" : "emphasized";

	const disabled = props.disabled;
	if(disabled){
		onPress = null;
		styleList.push(styles.disabled);
	}

	if (isAta) {
		return (
			<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${id}`} key={disabled} accessibilityComponentType="button" onPress={onPress} style={styleList}>
				<StyledIcon color={"#44898D"} name={icon} size={iconSize} contrast={contrast} />
				<StyledText testID={id + "_text"} tertiary={tertiary} color={"#44898D"} size={textSize} contrast={contrast}>
					{title}
				</StyledText>
				{children}
			</TouchableOpacity>
		);
	} else {
		return (
			<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${id}`} key={disabled} accessibilityComponentType="button" onPress={onPress} style={styleList}>
				<StyledIcon color={color} name={icon} size={iconSize} contrast={contrast} />
				<StyledText testID={id + "_text"} tertiary={tertiary} color={color} size={textSize} contrast={contrast}>
					{title}
				</StyledText>
				{children}
			</TouchableOpacity>
		);
	}
}